import Image from 'next/image';
import { isEqual } from 'lodash';
import Link from 'next/link';

import { splittedString } from '../../../utils/stringUtils';
import { ProductCategoryModel } from '../../../interface/products';
import { SUBZERO_BRAND_NAME } from '../../../constants/brands';
import { CATEGORY_DESCRIPTION_MAX_LENGTH } from '../../../constants/category';

/* eslint-disable-next-line */
type ProductCategoryCardProps = {
  brandTitle: string;
  category: ProductCategoryModel;
  ctaLink: string;
};

export function ProductCategoryCard(props: ProductCategoryCardProps) {
  const { brandTitle, category, ctaLink } = props;

  const displayDescription =
    category.categoryDescription &&
    splittedString(
      category?.categoryDescription,
      CATEGORY_DESCRIPTION_MAX_LENGTH
    );

  const hoverColor = isEqual(brandTitle, SUBZERO_BRAND_NAME)
    ? 'hover:bg-primaryBlue text-primaryBlue'
    : 'hover:bg-primaryRed text-primaryRed';

  return (
    <div className={`flex flex-col bg-secondaryGray hover:opacity-90 my-2`}>
      <Image
        alt="Category Image"
        blurDataURL="/icons/blur-placeholder.png"
        height={300}
        objectFit="cover"
        placeholder="blur"
        src={category.categoryImage.data.attributes.url}
        width={500}
      />
      <div
        className={`p-4 bg-headerBackground hover:text-white group py-12 card-content ${hoverColor}`}
      >
        <p className="uppercase font-bold text-primaryGray text-header6 group-hover:text-white">
          {category.categoryTitle}
        </p>
        <p className="pt-2 text-primaryGray group-hover:text-white">
          {displayDescription}
        </p>
        <div className="mt-4">
          <Link href={ctaLink} passHref>
            <a className="font-bold text-subtitle lg:text-body uppercase font-MuseoSans100">
              Explore Range &gt;
            </a>
          </Link>
        </div>
      </div>
    </div>
  );
}

export default ProductCategoryCard;
